import Grid from '@mui/material/Unstable_Grid2/Grid2'
import OneModal from '../OneModal/OneModal'
import { Typography } from '@mui/material'
import { Info } from '@mui/icons-material'
import OneTextArea from '../OneTextArea/OneTextArea'
import { useContext } from 'react'
import { VisitantesContext } from '../../Providers/VisitantesContext/VisitantesContext'

const PessoalInfoModal = ({ openInfoPessoa, setOpenInfoPessoa, pessoa, facial = true }) => {
    const { activeCond } = useContext(VisitantesContext)
    const caminhoImg = pessoa.IMAGEMPERFIL
        ? `${window.location.origin.replace(':3003', '')}/wsOnePortaria/web/images/${activeCond.id_central}/f${pessoa.CD_VISITANTE}.jpg`
        : `${window.location.origin.replace(':3003', '')}/wsOnePortaria/web/images/${pessoa.IMAGEMPERFIL}`

    return (
        <OneModal
            open={openInfoPessoa}
            setOpen={setOpenInfoPessoa}
            titleText="Informações"
            TitleIcon={ Info }
        >
            <Grid container sx={container1}>
                <Grid item xs={5}>
                    <img
                        src={caminhoImg}
                        alt="Erro ao buscar imagem ou falta da imagem"
                        width={'100%'}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography>Nome: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{pessoa.nome}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>{activeCond.pais === 'es-CL' ? 'RUT' : 'CPF'}: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{pessoa.cpf}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>Fone: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{pessoa.telefone}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>Tipo: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{pessoa.funcao}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>Placa: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{pessoa.placa}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>Observações: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <OneTextArea
                                name="observacoes"
                                defaultValue={pessoa.obs}
                                readOnly={true}
                                // onChange={handleChange}
                                newSx={textAreaSx}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </OneModal>
    )
}

export default PessoalInfoModal

const container1 = {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: '20px'
}
const formGroupTextValue = {
    fontWeight: 'bold'

}
const textAreaSx = {
    height: '100px',
    width: '100%'
}
